<script setup lang="ts">
import type { LinkedToItem } from "@/store/issueSelector";

defineProps<{ items: readonly LinkedToItem[] }>();
</script>

<template>
  <div>{{ $t("issueSelector.linkedTo") }}</div>
  <ul v-if="items.length" class="shortcut">
    <li v-for="item in items" :key="item.id">{{ item.text }}</li>
  </ul>
</template>
